module.exports = __webpack_public_path__ + "static/scale-model-of-turquoise-museum-in-albuquerque-new-mexico-326169e55696d6b9cff54e25a92a73c5.png";